module.exports = __webpack_public_path__ + "static/media/right-arrow.b55bad77.svg";